import { type Account, ChainNamespaces, isChainFullId, parseChainFullId } from "@umami/chains";

export const getFlattenedAccountsByChains = (accounts: Account[]) =>
  accounts.flatMap(account =>
    Object.entries(account.chains || {}).map(([chainId, chainInfo]) => ({
      name: account.label,
      pkh: chainInfo?.address.pkh ?? "",
      chainNamespace: isChainFullId(chainId)
        ? parseChainFullId(chainId).namespace
        : ChainNamespaces.TEZOS,
    }))
  );
